import Dialog from '@mui/material/Dialog';
import React from 'react';

import { DeleteLifeAreaSectionMessage } from './delete-life-area-section-message';

export type DeleteLifeAreaSectionDialogProps = {
  open: boolean;
  name?: string;
  onClose: () => void;
  onSubmit: (deleteTasks: boolean) => void;
};

export const DeleteLifeAreaSectionDialog: React.FC<
  DeleteLifeAreaSectionDialogProps
> = ({ open, name, onClose, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DeleteLifeAreaSectionMessage
        name={name}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    </Dialog>
  );
};
